import * as actions from '../actions/firebaseActions';

const initialState =  {
  gameUser: null,
  gameBat: null,
  termsAgreed: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_GAME_USER:
      return {
        ...state,
        gameUser: action.payload || null
      };
    case actions.FETCH_GAME_BAT:
      return {
        ...state,
        gameBat: (action.payload) ?  { id: action.payload } : null
      };
    case actions.FETCH_TERMS_AGREED:
      return {
        ...state,
        termsAgreed: action.payload || null
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/firebaseReducer.js